import React, { useState, useEffect } from 'react';
import AdminBaseLayout from '../../components/layouts/AdminBaseLayout';
import {
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Box,
  IconButton,
  Tooltip
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import withAuthAdmin from '../../middleware/useWithAuthAdmin';
import AuditHttpService from '../../api/AuditHttpService';
import LoadingOverlay from '../../components/LoadingOverlay';

function AdminAudit() {
  const [audits, setAudits] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [loading, setLoading] = useState(false);

  const fetchAudits = async (pageNumber = page + 1) => {
    try {
      setLoading(true);
      const response = await AuditHttpService.getAudits(pageNumber, rowsPerPage);
      setAudits(response.data);
      setTotalItems(response.pagination.total);
      setTotalPages(response.pagination.total_pages);
    } catch (error) {
      console.error('Error fetching audits:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAudits();
  }, [page, rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDownload = (url) => {
    window.open(url, '_blank');
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <AdminBaseLayout>
      <Box sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
          Auditoria de Arquivos
        </Typography>

        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
          <TableContainer>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Admin</TableCell>
                  <TableCell>Ação</TableCell>
                  <TableCell>Data</TableCell>
                  <TableCell align="center">Ações</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {audits.map((audit) => (
                  <TableRow key={audit.id}>
                    <TableCell>{audit.id}</TableCell>
                    <TableCell>{audit.admin_name}</TableCell>
                    <TableCell>{audit.name}</TableCell>
                    <TableCell>
                      {formatDate(audit.created_at)}
                    </TableCell>
                    <TableCell align="center">
                      <Tooltip title="Download">
                        <IconButton
                          onClick={() => handleDownload(audit.file)}
                          color="primary"
                        >
                          <DownloadIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 20, 50]}
            component="div"
            count={totalItems}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Box>
      {loading && <LoadingOverlay />}
    </AdminBaseLayout>
  );
}

export default withAuthAdmin(AdminAudit);
